export interface IUtente {
  _id: string;
  name: string;
  username: string;
  password: string;
  role: string;
  ruolo: any;
  enable: boolean;
  registeredOn: Object;
  lastLogin: Object;
  admin?: number;
  agente: string;
  cliente: any;
  tipoIntervento: any;
}

export const INITIAL_IUTENTE: IUtente = {
  _id: null,
  name: '',
  username: '',
  password: '',
  role: '0',
  ruolo: '0',
  enable: false,
  registeredOn: {
    formatted: ''
  },
  lastLogin: {
    formatted: ''
  },
  agente: '',
  cliente: '',
  tipoIntervento: '0'
};
